export enum WalletType {
  Card = 'card',
  Crypto = 'crypto',
}

export enum ApiWalletType {
  Master = 'Master wallet',
  Card = 'Card wallet',
  Crypto = 'Crypto wallet',
  Agent = 'Agent wallet',
}

export enum WalletTypeId {
  Master = 1,
  Card = 2,
  Crypto = 3,
  Agent = 4,
}
